<script>
import Vue from 'vue'
import DibbleJS from "../../../dibble";
import DibbleApi from "../../../api";
import Vuelidate from 'vuelidate'
import { required, email } from "vuelidate/lib/validators";
import DibbleTranslation from "../../../translation/translation";
import TextField from "@/commons/FormElements/TextField.vue";
import SelectField from "@/commons/FormElements/SelectField.vue";


Vue.use(Vuelidate)
export default {
    name: "ModalAddNewUser",
    components: {SelectField, TextField},
    props: {
        allPermissionLevels: Object,
        permissionLevels: Object
    },
    data() {
        return {
            dibbleJs: DibbleJS,
            translation: DibbleTranslation,
            mode: 'add',
            data: null,
            isEditable: true,
            form: {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                permission_level: ''
            },
            permissionLevelOptions: [],
        }
    },
    created() {
        this.$parent.$on('setUserData', this.loadData);
        for(let key in this.permissionLevels) {
            this.permissionLevelOptions.push({
                value: key,
                label: this.permissionLevels[key]
            })
        }
    },
    methods: {
        loadData(data) {
            this.data = data
            this.mode = 'edit'
            this.form = {
                ...data
            }
            this.form.permission_level = data.permission_level.toString()

            if (!data.is_status_editable) {
                this.isEditable = false

                this.permissionLevelOptions = [];
                for(let key in this.allPermissionLevels) {
                    this.permissionLevelOptions.push({
                        value: key,
                        label: this.allPermissionLevels[key]
                    })
                }
            } else {
                this.isEditable = true
            }
        },
        closeModal() {
            this.isEditable = true;
            this.$emit('close');
        },
        resetModalData() {
            this.$v.$reset()
            this.mode = 'add';
            this.data = null;
            this.form = {
                first_name: '',
                last_name: '',
                phone_num: '',
                email: '',
                permission_level: '',
            }
        },
        saveUserInfo() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                DibbleJS.toastErrorMessage(DibbleTranslation.trans('global.error.field.complete_all'))
                return false
            }

            if (this.mode === 'add') {
                this.performAddUser()
            } else {
                this.performUpdateUser()
            }
        },
        performAddUser() {
            const params = {
                '#request': DibbleApi.api.createUser,
                ...this.form,
                phone_num: this.form.phone
            }

            delete params['phone']

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, this._onAddUserSuccess)
        },
        performUpdateUser() {
            const params = {
                '#request': DibbleApi.api.updateUser,
                user_id: this.data['user_id'],
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                permission_level: this.form.permission_level,
                email: this.form.email,
                phone_num: this.form.phone
            }

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, this._onAddUserSuccess)
        },
        _onAddUserSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                DibbleJS.toastSuccessMessage(response.message)
                this.isEditable = true;
                this.resetModalData()
                this.$emit('modalListener', 'reload');
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        },
    },
    validations: {
        form: {
            first_name: { required },
            last_name: { required },
            phone: { required },
            email: { required, email },
            permission_level: { required },
        }
    }
}
</script>
<template src="../template/sub-components/modal-add-user.html"> </template>
<style lang="scss">
#modalEditBanner {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: #FFFFFF;
    transition: opacity .15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease
}

.user-form-role {
    position: relative;
    padding: 10px 10px 10px 35px !important;
}

.user-form-role input[type='radio'] {
    position: absolute;
    left: 3px;
    top: 12px;
    width: 15px;
    height: 15px;
}

.user-form-role span {
    color: #cacaca;
}


.custom-form-group {
    width: 90% !important;
    background: #E8EFF1;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.01em;
    color: #555E67;
}

.input-password {
    input {
        width: 90%;
    }
}
</style>
<style lang="scss" scoped>
// checkbox
.checkbox-custom {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 20px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
}

/* Hide the browser's default checkbox */
.checkbox-custom input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    border: none;
    pointer-events: none;

}

/* Create a custom checkbox */
.checkmark-new {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background: #DEE6EA;
    border: none !important;
    border-radius: 9px;
    pointer-events: none;

}

/* When the checkbox is checked, add a blue background */
.checkbox-custom input:checked~.checkmark-new {
    background-color: #2C94AB;
}

/* Show the checkmark when checked */
.checkbox-custom input:checked~.checkmark-new:after {
    display: block;
}

/* Style the checkmark/indicator */
.checkbox-custom .checkmark-new:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 8px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(40deg);
    -ms-transform: rotate(40deg);
    transform: rotate(40deg);
}

.list-checbox {
    display: flex;
    justify-content: space-around;
    width: 100%;

    .checkbox-item {
        display: flex;
        align-items: center;

        .active {
            color: #2C94AB;
        }

        p {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            color: #555E67;
            margin-bottom: 0;
        }

    }
}

.has-error {
    >div {
        border: 1px solid red !important;
    }

    >p {
        font-size: 13px;
        color: red;
    }
}

.opacity-50 {
    opacity: 0.5;
}
</style>
